import { useRouter } from '@/hooks/useRouter';
import paths from '@/routes/paths';
import './not-found-page.scss';
import { Button } from '@/components/shadcn/button/button';

const NotFoundPage = () => {
	const router = useRouter();

	return (
		<div className="not-found-page">
			<div className="not-found-content">
				<h1>404</h1>
				<h2>페이지를 찾을 수 없습니다</h2>
				<p>
					{`요청하신 페이지가 존재하지 않거나, \n이동되었을 수 있습니다.`}
				</p>

				<Button
					variant="secondary"
					size="md-round"
					onClick={() => router.push(paths.home)}
				>
					홈으로 돌아가기
				</Button>
			</div>
		</div>
	);
};

export default NotFoundPage;
